import i18n from "i18n";
import Controllers from "./UsersPermissionsManagementComponents/controllers/Conrollers";
import Volunteers from "./UsersPermissionsManagementComponents/volunteers/Volunteers";
import { UsersPermissionsManagementTabConfig } from "./UsersPermissionsManagementTypes";

export const USERS_PERMISSIONS_MANAGEMENT_TABS: UsersPermissionsManagementTabConfig[] =
  [
    {
      tabName: "controllers",
      tabTitle: i18n.t("controllers"),
      tabComponent: Controllers,
    },
    {
      tabName: "volunteers",
      tabTitle: i18n.t("volunteers"),
      tabComponent: Volunteers,
    },
  ];

export const isValidIsraeliID = (idToCheck: string) => {
  const id = String(idToCheck).trim();

  if (id.length !== 9) {
    return false;
  }

  return (
    Array.from(id, Number).reduce((counter, digit, i) => {
      const step = digit * ((i % 2) + 1);
      return counter + (step > 9 ? step - 9 : step);
    }) %
      10 ===
    0
  );
};
